import React, { useEffect } from 'react';

const LoginRequiredModal = ({ isOpen, onClose, title = '로그인이 필요한 서비스입니다', message = '로그인 후 이용해주세요.' }) => {
  useEffect(() => {
    if (!isOpen) return;
    const handleEscape = (e) => {
      if (e?.key === 'Escape') {
        onClose?.();
      }
    };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);

  useEffect(() => {
    if (!isOpen) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[10050] flex items-center justify-center px-4"
      onClick={(e) => {
        if (e?.target === e?.currentTarget) onClose?.();
      }}
      role="dialog"
      aria-modal="true"
    >
      <div className="fixed inset-0 bg-background/70 backdrop-blur-sm" aria-hidden="true" />

      <div className="relative z-10 w-full max-w-sm rounded-xl border border-border bg-card shadow-elevation-3 animate-in fade-in zoom-in-95 duration-200">
        <div className="p-6">
          <div className="flex items-start justify-between gap-4">
            <div className="min-w-0">
              <p className="text-base font-semibold text-foreground">{title}</p>
              <p className="mt-2 text-sm text-muted-foreground caption whitespace-pre-line">{message}</p>
            </div>
            <button
              type="button"
              onClick={() => onClose?.()}
              className="shrink-0 inline-flex items-center justify-center w-9 h-9 rounded-md text-muted-foreground hover:text-foreground hover:bg-muted transition-smooth"
              aria-label="닫기"
            >
              ✕
            </button>
          </div>

          <div className="mt-6 flex gap-2">
            <button
              type="button"
              onClick={() => onClose?.()}
              className="flex-1 h-10 rounded-lg bg-primary text-primary-foreground text-sm font-semibold transition-smooth hover:opacity-95"
            >
              확인
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginRequiredModal;
